import {HttpResponse} from "@angular/common/http";
import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {CompanyDto, ConfiguratorCompanyService, DatastoreDto,} from "@tj/tj-dmp-lib-api";
import {ConfirmationService, MenuItem, MessageService} from "primeng/api";
import { TranslateService } from "@ngx-translate/core";

@Component({
    templateUrl: "./company.component.html",
    styleUrls: ["./company.component.scss"],
    standalone: false
})
export class CompanyComponent implements OnInit {
    get locale(): string { return this.translate.getCurrentLang() === 'en' ? 'en-GB' : 'fr-FR'; }

    breadcrumb: MenuItem[] = [
        { label: this.translate.instant('menu.invoice.label') },
        { label: this.translate.instant('menu.invoice.companies') },
    ];
    description = this.translate.instant('invoicing.companies.description');

    datastore: DatastoreDto;

    companies: CompanyDto[] = [];
    actual: CompanyDto;

    showDetails = false;

    state: { message: string };

    items = [
        {
            label: this.translate.instant('invoicing.common.view'),
            items: [
                {
                    label: this.translate.instant('invoicing.common.more'),
                    icon: "fas fa-user",
                    permission: "INVOICECOMPANIES.read",
                    command: () => {
                        this.showDetails = true;
                    },
                },
            ],
        },
        {
            label: this.translate.instant('invoicing.common.manage'),
            items: [
                {
                    label: this.translate.instant('invoicing.common.edit'),
                    icon: "fas fa-pen",
                    permission: "INVOICECOMPANIES.edit",
                    command: () => {
                        this.router.navigate([
                            `/h/invoicing/company/edit/${this.datastore.code}/${this.actual.id}`,
                        ]);
                    },
                },
                {
                    label: this.translate.instant('invoicing.common.delete'),
                    icon: "fas fa-trash",
                    permission: "INVOICECOMPANIES.delete",
                    command: () => {
                        this.confirmationService.confirm({
                            message: this.translate.instant('invoicing.companies.deleteConfirm', {name: this.actual.name}),
                            accept: () => {
                                this.configuratorCustomerService
                                    .deleteCompanyUsingDELETE(
                                        this.datastore.code,
                                        this.actual.id
                                    )
                                    .subscribe(
                                        () => {
                                            this.loadAll();
                                            this.messageService.add({
                                                severity: "success",
                                                summary: this.translate.instant('invoicing.common.success'),
                                                detail: this.translate.instant('invoicing.companies.deleted'),
                                            });
                                        },
                                        (e) => {
                                            this.messageService.add({
                                                severity: "error",
                                                summary: this.translate.instant('invoicing.common.error'),
                                                detail: this.translate.instant('invoicing.common.genericError', {error: e.toString()}),
                                            });
                                        }
                                    );
                            },
                        });
                    },
                },
            ],
        },
    ];

    constructor(
        private configuratorCustomerService: ConfiguratorCompanyService,
        private confirmationService: ConfirmationService,
        private router: Router,
        private messageService: MessageService,
        private readonly translate: TranslateService
    ) {
        const navigation = this.router.getCurrentNavigation();
        const state = navigation?.extras?.state as { message: string } | undefined;
        this.state = state;
    }

    ngOnInit(): void {
        if (this.state?.message === "success_created") {
            setTimeout(() =>
                this.messageService.add({
                    severity: "success",
                    summary: this.translate.instant('invoicing.common.success'),
                    detail: this.translate.instant('invoicing.companies.created'),
                })
            );
        } else if (this.state?.message === "success_updated") {
            setTimeout(() =>
                this.messageService.add({
                    severity: "success",
                    summary: this.translate.instant('invoicing.common.success'),
                    detail: this.translate.instant('invoicing.companies.updated'),
                })
            );
        }
    }

    datastoreChange(datastore: DatastoreDto) {
        this.datastore = datastore;
    }

    loadAll() {
        if (this.datastore) {
            this.configuratorCustomerService
                .getAllCompaniesUsingGET(
                    this.datastore.code,
                    "response"
                )
                .subscribe(
                    (res: HttpResponse<CompanyDto[]>) => {
                        this.companies = res.body || [];
                    },
                    () => {
                        this.companies = [];
                    }
                );
        } else {
            this.companies = [];
        }
    }

    navigateToDetail(companie: CompanyDto) {
        this.actual = companie;
        this.showDetails = true;
    }
}
